import React from 'react';
import SSO_Redirection from 'app/redirection-SSO';
import CRMflows_Redirection from 'app/redirection-CRMflows';
import { UilExchange } from '@iconscout/react-unicons';
import './redirectComp.scss';
import PopMenu, { PopMenuItem } from './popmenu';
import Tracker from 'app/tracking/tracking-service';
import { Enums } from 'services/dropdown-enums';

const RedirectComp = ({ showSideBar, switchTo }) => {
  const redirectHandler = () => {
    // call Tracker event for switchTo
    Tracker.EventsProvider(
      Enums.TrackerType.GoogleAnalytics
    ).Redirection.SwitchToLegacyPortal();

    // redirection here..
    SSO_Redirection();
  };
  const crmFlowsRedirectHandler = () => {
    CRMflows_Redirection();
  };

  return (
    <>
      <PopMenu
        id="introJS-item-switch"
        showSideBar={showSideBar}
        title={'Switch'}
        toolTipText={'Switch'}
        menuHeading={'Switch'}
        showTooltip={false}
        path={undefined}
        icon={<UilExchange size="24" className="sidebar-link" />}
      >
        {props => {
          return (
            <>
              {switchTo.allowPortal && (
                <PopMenuItem
                  text={`Legacy Portal`}
                  handler={() => {
                    props.menuSet(false);
                    redirectHandler();
                  }}
                  loading={false}
                />
              )}
              {switchTo.allowCRM && (
                <PopMenuItem
                  text={`CRM flows`}
                  handler={() => {
                    props.menuSet(false);
                    crmFlowsRedirectHandler();
                  }}
                  loading={false}
                />
              )}
            </>
          );
        }}
      </PopMenu>
    </>
  );
};

export default RedirectComp;
